<template>
    <div :style="$bgColor(color.background)" class="card mt-6 mx-2 col-sm-12 col-md-5 col-lg-3">
        <div class="justify-content-center">
            <div class="card-profile-image">
                <img class="round" :src="image(member.upload, 'thumb')" alt="profile picture">
            </div>
        </div>
        <div class="card-body">
            <h3 :style="{ color: color.name }" class="card-title text-center mt-6">{{member.translation.name}}</h3>
            <h4 :style="{ color: `${color.title} !important`}" class="category text-primary text-center">{{member.translation.title}}</h4>
            <p :style="{ color: color.description }" class="line-break card-description text-justify">{{member.translation.description}}</p>
        </div>
    </div>
</template>

<script>
import image from '../../mixins/image'

export default {
    name: 'HomeTeamMember',
    mixins: [image],
    props: {
        member: {
            type: Object,
            required: true
        },
        color: {
            type: Object,
            required: true
        }
    },
    computed: {
        bgImage() {
            return {
                'backgroundImage': `url(${this.member.upload})`,
                'backgroundSize': 'cover',

            }
        }
    }
}
</script>

<style>
.line-break{
    white-space: pre-line
}
</style>
